import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { Field, reduxForm } from "redux-form";

class MyAssayToggle extends Component {
  handleMyAssayToggle() {
    document.location.href = "/digital-assays/#/assay-design-history";
  }

  render() {
    return (
      <div id="myassay-toggle" className="d-print-none">
        <div className="row">
          <div className="col">
            <Field
              component="input"
              name="assayTypeToggle"
              type="radio"
              value="non-gex"
              onChange={this.handleMyAssayToggle}
            />{" "}
            Assays (excluding Gene Expression)
          </div>
        </div>
        <div className="row">
          <div className="col">
            <Field
              component="input"
              name="assayTypeToggle"
              type="radio"
              value="gex"
              onChange={this.handleMyAssayToggle}
            />{" "}
            Gene Expression Assays
          </div>
        </div>
      </div>
    );
  }
}

const stateToProps = state => ({
  initialValues: {
    assayTypeToggle: "gex"
  }
});

MyAssayToggle = reduxForm({
  form: "frmMyAssayToggle",
  enableReinitialize: true
})(MyAssayToggle);

MyAssayToggle = withRouter(
  connect(
    stateToProps,
    {}
  )(MyAssayToggle)
);

export default MyAssayToggle;
